// import { h, render } from 'preact';
// import { useState } from 'preact/hooks';
import WidgetFactory from './core/WidgetFactory';
import GlobalVariables from './core/GlobalVariables';
import WidgetTypes from './core/enums/WidgetTypes';
import TempCache from './core/enums/TempCache';
import TimeType from './core/hooks/TimeType';
import CompanyLevelBlockValidator from './core/hooks/CompanyLevelBlockValidator';
import ChatMode from './core/hooks/ChatMode';
import logWidgetShown from './core/hooks/logWidgetShown';
import { ChatType, ThemeStyle } from './core/enums/Enum';
// import fixFlash from './core/hooks/fixFlash';
import WebStorage from './core/hooks/WebStorage';
import loadJQuery from './core/hooks/loadJQuery';
import loadJQueryPlugins from './core/loadJQueryPlugins';
import createLinkElementInDOM from './core/hooks/createLinkElementInDOM';
import getRandomItem from './core/hooks/getRandomItem';
import Cookies from './core/hooks/Cookies';
import WidgetStates from './core/hooks/WidgetStates';
import getCookieValue from './core/hooks/getCookieValue';
import storageAPIExists from './core/hooks/storageAPIExists';
import logIt from '../logIt';
import saveGoogleAnalyticsClientId from './core/hooks/saveGoogleAnalyticsClientId';
import configureDataDog from './core/hooks/configureDataDog';
import setSkinType from './core/hooks/setSkinType';
// import Counter from './components/Counter';
// //import styles from './Styles.css';

// function App() {
//     return (
//         <p className="text">
//             Hello World! <Counter />
//         </p>
//     );
// }

export default class InvitationHandler {
    async init(options) {
        if (
            typeof GlobalVariables.CompanyLevelBlockedPages !== 'undefined' &&
            typeof GlobalVariables.CompanyContextRequest !== 'undefined'
        ) {
            this.companyLevelBlockValidator = new CompanyLevelBlockValidator(
                GlobalVariables.CompanyLevelBlockedPages,
                GlobalVariables.CompanyContextRequest,
                GlobalVariables.CompanyLevelSettings
            );
        }

        // const tabWidgetRoot = document.createElement('div');
        // tabWidgetRoot.setAttribute('id', 'tabWidget');
        // tabWidgetRoot.attachShadow({
        //     mode: 'open'
        // });

        // document.body.appendChild(tabWidgetRoot);

        // const preChatWidgetRoot = document.querySelector('#app');
        // preChatWidgetRoot.attachShadow({
        //     mode: 'open'
        // });

        // const link = document.createElement('link');
        // link.rel = 'stylesheet';
        // link.type = 'text/css';
        // link.href = `${options.domain}scripts/tabs/styles.css`;
        // link.media = 'all';
        // // console.log(styles);
        // preChatWidgetRoot.shadowRoot.appendChild(link);

        // render(<App />, preChatWidgetRoot.shadowRoot);
        // works like main method
        // make sure this only runs once otherwise v3 widgets can malfunction due to state management issues; e.g. manageStateForShownInvitation
        if (window.ApexChat && window.ApexChat.invitationv3run) {
            return;
        }
        // CHANGE THE PUBLIC PATH OF THE WEBPACK ON THE FLY
        // THIS WILL WORK ON INCLUDING FILES 'bundleEntries/invitation.js'
        const domain = GlobalVariables.CdnBaseUrl
            ? `${GlobalVariables.CdnBaseUrl}`
            : options.domain;
        __webpack_public_path__ = `${domain}contents/scripts/dist/`;
        console.log(`public path: ${__webpack_public_path__}`);
        window.ApexChat.invitationv3run = true;
        // initialize appInsights
        if (env.DataDog && options.telemetryEnabled) {
            configureDataDog();
        }
        TempCache.VERSION_INFO = {
            'Profile Version': '3'
        };

        // extend invitation options with custom options
        if (options.profileTexts) {
            options.profileTextsHash = {};
            for (let i = 0; i < options.profileTexts.length; i++) {
                const profileText = options.profileTexts[i];
                options.profileTextsHash[profileText.threeLetterISOLanguageName] = profileText;
            }
        }
        this.manageStateForShownInvitation(options);
        this.options = options;
        this.applyMobileViewport();
        // set the agentaliasid cookie for an hr
        this.agentAliasId = getCookieValue(TempCache.AGENT_ALIAS_ID_COOKIE);
        this.updateAliasCookieValue = false;
        this.showAgentImage();
        if (this.updateAliasCookieValue) {
            Cookies.set(TempCache.AGENT_ALIAS_ID_COOKIE, this.options.agentAliasId, 1 / 24);
            this.agentAliasId = this.options.agentAliasId;
        }
        // fix flash, if necessary
        // if (options.fixFlash) {
        //     fixFlash();
        // }
        // // if this frameBuster logic is related to DropDown only, move it in there
        // if (options.frameBuster) {
        //     let frameBustCounter = 0;
        //     let frameBustInterval;
        //     let frameBusterFn;
        //     const frameBustCookieName = 'APEX_FRAME_BUST_COUNT';
        //     if (Cookies.get(frameBustCookieName)) {
        //         frameBustCounter = parseInt(Cookies.get(frameBustCookieName), 10);
        //     }
        //     options.frameBusterMessage =
        //         options.frameBusterMessage ||
        //         'WARNING: You are viewing this page in an unauthorized frame window!';
        //     frameBusterFn = function () {
        //         if (top != self) {
        //             // first, simply try to bust out of the frame;
        //             // we'll track attempts to do this
        //             frameBustCounter++;
        //             Cookies.set(frameBustCookieName, frameBustCounter);
        //             // 5 attempts (total of 5s)
        //             // if no luck, we're in a frame, and we shouldn't be. Notify the user.
        //             if (frameBustCounter > 5) {
        //                 const div = document.createElement('div');
        //                 div.style.position = 'absolute';
        //                 div.style.top = 0;
        //                 div.style.left = 0;
        //                 div.style.zIndex = '999999999';
        //                 div.style.width = '100%';
        //                 div.style.height = '100%';
        //                 div.style.backgroundColor = 'rgba(0,0,0,0.75)';
        //                 div.style.color = '#fff';
        //                 div.style.textAlign = 'center';
        //                 div.style.fontSize = '24px';
        //                 div.style.paddingTop = '150px';
        //                 div.innerHTML = `${options.frameBusterMessage}<br/><br/><a style="color:#fff;text-decoration:underline" href="${self.location.href}" target="_blank">Click here to resolve this.</a>`;
        //                 ApexChat.getBody().appendChild(div);
        //                 window.clearInterval(frameBustInterval);
        //                 Cookies.set(frameBustCookieName, '0');
        //             } else {
        //                 top.location.replace(self.location.href);
        //             }
        //         } else {
        //             window.clearInterval(frameBustInterval);
        //         }
        //     };
        //     frameBustInterval = window.setInterval(frameBusterFn, 1000);
        //     // run 1x right away
        //     frameBusterFn();
        // }

        // set the operatorId cookie for 10 mins
        this.operatorId = getCookieValue(TempCache.OPERATOR_ID_COOKIE);
        if (!this.operatorId) {
            Cookies.set(TempCache.OPERATOR_ID_COOKIE, this.options.operatorId, 1 / 144);
            this.operatorId = this.options.operatorId;
        }
        if (this.options.operatorInfo) {
            this.options.handlerImageUrl = this.options.operatorInfo.imageCloudSecureUrl;
            this.options.agentName = this.options.operatorInfo.displayName;
        }
        // set the visitor Id cookie for 365 days
        this.visitorId = getCookieValue(TempCache.VISITOR_ID_COOKIE);
        if (!this.visitorId) {
            Cookies.set(TempCache.VISITOR_ID_COOKIE, this.options.visitorId, 365);
            this.visitorId = this.options.visitorId;
        }
        // set the profile for 1 day
        this.profileId = getCookieValue(TempCache.PROFILE_ID_COOKIE);
        if (!this.profileId) {
            Cookies.set(TempCache.PROFILE_ID_COOKIE, this.options.profileId, 1);
            this.profileId = this.options.profileId;
        }
        if (this.options.agentName) {
            this.agentName =
                this.options.agentName.charAt(0).toUpperCase() +
                this.options.agentName.substring(1);
        }
        // export options globally - inside iframes with parent.ApexChat.options
        window.ApexChat.options = this.options;

        window.ApexChat = setSkinType(
            window.ApexChat || {},
            window.ApexChat.Invitation?.config?.skinThemeStyle
        );
        if (options.companyChatbot) {
            window.ApexChat.options.aiBotEnabled = true;
        }
        // Track Google Analytics Client Id
        saveGoogleAnalyticsClientId(
            this.options.companyTrackingSettings.googleAnalyticsMeasurementId
        );
        // finally, create all widgets that are enabled

        const loadInvitations = async () => {
            logWidgetShown(this.options.companyKey);
            logIt('jquery loaded; initializing widgets now...');
            // RegisterBaseWidgetClient(); // initialize base client type so other widgets can be created below
            await this.createInvitations();
            await this.createChatWindows();
            if (this.isSmsEnabled()) {
                const widget = new WidgetFactory(WidgetTypes.WebSmsForm, ApexChat.options);
                await widget.create();
            }
            // var test = parseTemplate(options.smsPopupFrameStyles, { iframeID: '#' + smsForm.iframeId });
            if (ApexChat.options.requestVisitorInfo && ApexChat.options.chatMode == ChatMode.DOM) {
                await this.createVisitorForm();
            }


            createLinkElementInDOM(
                `${GlobalVariables.CdnBaseUrl}contents/scripts/dist/${ApexChat.Theme}/index.css?ver=${env.BUILD_HASH}`
            );
        };
        await loadInvitations();
    }

    manageStateForShownInvitation(options) {
        // We need to clear state of prechat if the ChatID is not there..
        if (
            !storageAPIExists(TempCache.CHAT_ID_COOKIE) &&
            storageAPIExists(TempCache.PreChat_Message_Sent)
        ) {
            this.clearPreChatState();
        }
        if (!storageAPIExists(TempCache.INVITATION_SHOWN)) {
            if (ApexChat.storageAPI.Get(WidgetTypes.DOM) !== WidgetStates.ShownMaximized) {
                ApexChat.storageAPI.Store(WidgetTypes.DropDown, WidgetStates.ShownMaximized);
                if (!storageAPIExists(TempCache.CHAT_ID_COOKIE)) {
                    // Removing Page Refresh cookie for avoiding Subsequent location of Invitation
                    ApexChat.storageAPI.Remove(TempCache.IS_PAGE_REFRESHED);
                }
            }
            // clear prechat state if enabled
            this.clearPreChatState();
            if (options.reShowIntervalMinutes) {
                // Storing Cookie for specific amount of time (minutes).
                ApexChat.storageAPI.StoreUntil(TempCache.INVITATION_SHOWN, true, {
                    timeType: TimeType.Minute,
                    expiringDuration: options.reShowIntervalMinutes
                });
            }
        }
        // to check page refresh subsequently
        if (storageAPIExists(TempCache.IS_PAGE_REFRESHED)) {
            ApexChat.storageAPI.Store(TempCache.IS_PAGE_REFRESHED, true);
        } else {
            ApexChat.storageAPI.Store(TempCache.IS_PAGE_REFRESHED, false);
        }
        // set original referrer cookie
        ApexChat.storageAPI.Store(
            TempCache.OriginalReferrer,
            encodeURIComponent(document.referrer).substring(0, 500)
        );
    }

    clearPreChatState() {
        ApexChat.sessionStorageAPI = ApexChat.sessionStorageAPI || WebStorage({ type: 'session' });
        ApexChat.sessionStorageAPI.Remove(TempCache.PreChat_Msg_Array);
        ApexChat.localStorageAPI.Remove(TempCache.PreChat_Msg_Array);
        ApexChat.storageAPI.Remove(TempCache.PreChat_Msg_Array);
        ApexChat.sessionStorageAPI.Remove(TempCache.PreChat_Messages_Store);
        ApexChat.storageAPI.Remove(TempCache.PreChat_Message_Counter);
        ApexChat.storageAPI.Remove(TempCache.PreChat_Last_Message);
        ApexChat.storageAPI.Remove(TempCache.PreChat_Message_IDs);
        ApexChat.storageAPI.Remove(TempCache.PreChat_Message_Sent);
    }

    isSmsEnabled() {
        const me = this;
        return (
            me.options.staticSmsEnabled ||
            (me.options.chatTab && me.options.chatTab.chatTabType == ChatType.sms) ||
            (me.options.chatbar && me.options.chatbar.chatBarType == ChatType.sms) ||
            (me.options.chatbar && me.options.chatbar.chatBarType == ChatType.facebook_sms) ||
            (me.options.chatbar && me.options.chatbar.chatBarType == ChatType.standard_sms) ||
            (me.options.chatbar && me.options.chatbar.chatBarType == ChatType.standard_sms_facebook)
        );
    }

    async createVisitorForm() {
        const widget = new WidgetFactory(WidgetTypes.VisitorForm, ApexChat.options);
        await widget.create();
    }

    async createDynamicVisitorForm() {
        const widget = new WidgetFactory(WidgetTypes.DynamicVisitorForm, ApexChat.options);
        await widget.create();
    }

    async createInvitations() {
        if (
            this.companyLevelBlockValidator &&
            this.companyLevelBlockValidator.isBlockedInvitation()
        ) {
            // company level block invitation
            return;
        }
        // JIRA_4044 - In case of Version #1  This comes null because it contains no ThemeBuilder settings.
        if (!ApexChat.options.invitationWidgetStyleCustom) {
            // It comes null in version #1
            ApexChat.options.invitationWidgetStyleCustom = '';
        }
        // ===== finally render all widgets/inv types enabled
        if (ApexChat.options.invitationWidgetStyleCustom.indexOf('IsChevronStyleDOM') !== -1) {
            ApexChat.options.isChevronStyleDOM = true;
        }
        ApexChat.options.ApexChatDefaultLogLevel = GlobalVariables.ApexChatDefaultLogLevel; // for debugging set this to 1
        // load all required resource files (js/css) as a hidden repo
        if (ApexChat.options.standardInvitationEnabled) {
            const widget = new WidgetFactory(WidgetTypes.DropDown, ApexChat.options);
            await widget.create();
        }
        if (ApexChat.options.chatbar) {
            const widget = new WidgetFactory(WidgetTypes.Bar, ApexChat.options);
            await widget.create();
        }
        if (ApexChat.options.chatTab) {
            const widget = new WidgetFactory(WidgetTypes.Tab, ApexChat.options);
            await widget.create();
        }
        if (ApexChat.options.staticSmsEnabled) {
            const widget = new WidgetFactory(WidgetTypes.SMS, ApexChat.options);
            await widget.create();
        }
        if (ApexChat.options.videoGreetEnabled) {
            await loadJQuery();
            loadJQueryPlugins(ApexChat.ApexChatJquery);
            const widget = new WidgetFactory(WidgetTypes.VideoGreetInvitation, ApexChat.options);
            await widget.create();
        }
        if (ApexChat.options.preChat) {
            const widget = new WidgetFactory(WidgetTypes.PreChat, ApexChat.options);
            await widget.create();
        }
        if (ApexChat.options.popupMessage?.enablePopUpMessageOverlay) {
            const widget = new WidgetFactory(WidgetTypes.PopupMessage, ApexChat.options);
            await widget.create();
        }

        // uncomment the following if you want to test out things using a TestWidget
        // var testWidget = WidgetFactory.create(WidgetTypes.Test, ApexChat.options);
    }

    async createChatWindows() {
        let chat_win_dom;
        if (ApexChat.options.chatMode == ChatMode.DOM) {
            const widget = new WidgetFactory(WidgetTypes.DOM, ApexChat.options);
            await widget.create();
        }
        if (
            ApexChat.options.exitPopupEnabled &&
            !(
                this.companyLevelBlockValidator &&
                this.companyLevelBlockValidator.isBlockedExitpopup()
            )
        ) {
            const widget = new WidgetFactory(WidgetTypes.ExitPopup, ApexChat.options);
            widget.create();
        }
        // nb. the following code will open Windowed chat
    }

    /* functions required to run only once on page */
    applyMobileViewport() {
        if (this.options.applyMobileViewport && this.options.isMobile) {
            const metaTags = document.getElementsByTagName('meta');
            let el = null;
            for (let i = 0; i < metaTags.length; i++) {
                if (metaTags[i].getAttribute('name') == 'viewport') {
                    el = metaTags[i];
                    break;
                }
            }
            if (!el) {
                el = document.createElement('meta');
                el.setAttribute('name', 'viewport');
                const head = document.getElementsByTagName('head')[0];
                head.appendChild(el);
            }
            el.setAttribute(
                'content',
                'width=device-width, initial-scale=1.0, minimum-scale=1.0, user-scalable=yes'
            );
        }
    }

    showAgentImage() {
        const me = this;

        if (!this.agentAliasId && !this.options.agentAliasId) {
            // no cookie set...check for the initializer. if not set there,
            // grab a random one and store in the options
            if (this.options.agentAliases) {
                // load up a random agent alias
                const randomAlias = getRandomItem(this.options.agentAliases);
                if (randomAlias) {
                    this.options.agentAliasId = randomAlias.id;
                    this.options.handlerImageUrl =
                        randomAlias.imageCloudSecureUrl ||
                        GlobalVariables.ApexChatBaseUrl + randomAlias.imagePath;
                    this.options.agentName = me.getAliasDisplayName(randomAlias);
                }
            }
            this.agentAliasId = this.options.agentAliasId;
            this.updateAliasCookieValue = true;
        } else {
            // if there is a value in the cookie for this user, find it
            // and load up the image, etc
            if (this.options.agentAliases) {
                let selectedAlias;
                for (let i = 0; i < this.options.agentAliases.length; i++) {
                    if (this.options.agentAliases[i].id === parseInt(this.agentAliasId, 0)) {
                        selectedAlias = this.options.agentAliases[i];
                        break;
                    }
                }
                // if not present then get the random value
                if (!selectedAlias) {
                    // get the random alias
                    selectedAlias = getRandomItem(this.options.agentAliases);
                    this.updateAliasCookieValue = true;
                }

                // set the values
                this.options.agentAliasId = selectedAlias.id;

                this.options.handlerImageUrl =
                    selectedAlias.imageCloudSecureUrl ||
                    `${GlobalVariables.ApexChatBaseUrl}contents/${selectedAlias.imagePath}`;
                this.options.agentName = me.getAliasDisplayName(selectedAlias);
            }
        }
    }

    getAliasDisplayName(alias) {
        return this.options.genericHandlerAliasingEnabled
            ? this.options.agentName
            : alias.displayName;
    }
}
